import {Box, Grid, Typography} from '@mui/material';
import {DialogTypes} from 'common/names';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import Dialog from 'components/Dialog';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import FormikCheckbox from 'components/inputs/FormikCheckbox';
import Panel from 'components/Panel';
import ReferenceItems from 'features/layout/CommonPage/panels/ReferencesPanel/ReferenceItems';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {IDiplomatObject} from 'types/DiplomatObject';

export type ITroubleShootingForm = {
   turnOffTroubleshooting: boolean;
};

export type TroubleShootingDialogData = {
   troubleshooters: IDiplomatObject[];
};
type Props = {
   onClose: (
      values: ITroubleShootingForm | false,
      callbacks?: FormOnSubmitHelpers<ITroubleShootingForm>
   ) => void;
   data?: TroubleShootingDialogData;
};
const TroubleShootingDialog = memo(({onClose, data}: Props) => {
   const {troubleshooters = []} = data || {};

   const _onClose = React.useCallback(() => onClose(false), [onClose]);

   return (
      <Dialog header={DialogTypes.TroubleShootingDialog.dialogName} close={_onClose}>
         <Formik
            initialValues={{
               turnOffTroubleshooting: false,
            }}
            onSubmit={onClose}
            initialTouched={['turnOffTroubleshooting']}
         >
            <TroubleShootingForm troubleshooters={troubleshooters} onClose={_onClose} />
         </Formik>
      </Dialog>
   );
});

function TroubleShootingForm({
   troubleshooters,
   onClose,
}: TroubleShootingDialogData & {onClose: () => void}) {
   const {t} = useTranslation();
   return (
      <>
         <Typography variant={'body2'}>
            {t(
               'Advanced Troubleshooting is currently enabled for the following list, and troubleshooting files will continue to be created.'
            )}
         </Typography>
         <Typography variant={'body2'}>
            {t('Disable Advanced Troubleshooting if no longer necessary.')}
         </Typography>
         <Box paddingTop={2}>
            <Panel name={t('Transactions with Advanced Troubleshooting')}>
               <ReferenceItems
                  data={troubleshooters}
                  noData={t('<No Transactions with Troubleshooting>')}
               />
            </Panel>
         </Box>
         <Grid container>
            <Grid item>
               <FormikCheckbox
                  name="turnOffTroubleshooting"
                  label={t('Turn off troubleshooting in all transactions')}
               />
            </Grid>
         </Grid>

         <FormFooterButtons submitLabel={t('Exit')} cancel={onClose} enableOk />
      </>
   );
}

export default TroubleShootingDialog;
